"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#bell_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.626 16.652c-.288.958 2.054 2.62 4.757 3.715a18.29 18.29 0 0 0 1.603.566c.757.227 1.566.41 2.367.544 2.685.447 5.283.338 5.548-.544.441-1.472-2.282-1.69-1.666-5.524.617-3.835-.294-6.088-2.439-6.73-2.144-.644-4.002.936-5.819 4.253-1.816 3.318-3.91 2.248-4.351 3.72Zm8.326 6.885a2.26 2.26 0 0 1-2.042 1.26c-1.363.006-2.479-1.23-2.336-2.532 1.088.524 2.866 1.142 4.378 1.272Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.796 8.678c-2.144-.643-4.002.937-5.819 4.254-1.816 3.318-3.91 2.248-4.351 3.72-.288.958 2.054 2.62 4.757 3.715a18.29 18.29 0 0 0 1.603.566c.757.227 1.566.41 2.367.544 2.685.447 5.283.338 5.548-.544.441-1.472-2.282-1.69-1.666-5.524.617-3.835-.294-6.088-2.439-6.73Zm0 0 .48-1.635M14.91 24.797a2.26 2.26 0 0 0 2.042-1.26c-1.512-.13-3.29-.748-4.378-1.272-.143 1.302.973 2.538 2.336 2.532Z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bell_svg__a",
    x1: 16,
    y1: 32,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27E4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#15C1C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#2E90EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#776CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#995EE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB47D1"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBell);
var _default = exports["default"] = Memo;